// extracted by mini-css-extract-plugin
export default {"wrapper":"x3","how_often":"y3","box":"z3","scoops":"A3"};
    if(module.hot) {
      // 1713361655492
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  